import { render, staticRenderFns } from "./AudioPlayButton.vue?vue&type=template&id=0fb0c238&scoped=true&"
import script from "./AudioPlayButton.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayButton.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AudioPlayButton.vue?vue&type=style&index=1&id=0fb0c238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb0c238",
  null
  
)

export default component.exports